import { FormattedMessage } from 'react-intl';

import { InstalmentTypes, InstalmentViewModel } from '../../../../../resources/contract/types';

import { ContractInstalmentLine } from './ContractInstalmentLine';
import s from './ContractInstalmentTable.module.css';

type Props = {
    instalments: Array<InstalmentViewModel>;
    type: InstalmentTypes;
};

export const ContractInstalmentTable = ({ instalments, type }: Props): JSX.Element => {
    if (instalments.length === 0) {
        return (
            <p className="ink-light">
                <FormattedMessage id={`contract.messages.no_${type}`} />
            </p>
        );
    }

    return (
        <div>
            <div className={s.headersTable}>
                <div className="ink-light">
                    <FormattedMessage id="contract.instalment.labels.status" />
                </div>
                <div className="ink-light">
                    <FormattedMessage id="contract.instalment.labels.date" />
                </div>
                <div className="ink-light">
                    <FormattedMessage id="contract.instalment.labels.payer" />
                </div>
                <div className="ink-light">
                    <FormattedMessage id="contract.instalment.labels.amount" />
                </div>
            </div>
            {instalments.map((instalment) => (
                <ContractInstalmentLine
                    instalment={instalment}
                    key={instalment.id}
                    index="contract.instalment"
                    currency={instalment.price.currency}
                />
            ))}
        </div>
    );
};
